<template>
  <table
    :id="id"
    class="table ist-table is-striped"
  >
    <thead>
      <tr>
        <th
          v-for="(label, i) in columnLabels"
          :key="i"
        >
          {{ label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(row, i) in rows"
        :key="i"
      >
        <td
          v-for="(col, j) in columns"
          :key="j"
        >
          {{ row[col] }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    id: String,
    rows: {
      type: Array,
      default() {
        return [
          { A: 'A1', B: 'B1' },
          { A: 'A2', B: 'B2' },
        ];
      },
    },
    columns: {
      type: Array,
      default() {
        return ['A', 'B'];
      },
    },
    columnLabels: {
      type: Array,
      default() {
        return ['first', 'second'];
      },
    },
  },
};
</script>
